/* mypka-hero-reveal-netz.js — myPKA, 18.08.2026
 *
 * Sicherheitsnetz fuer die Reveal-Animation der Hero-Ueberschrift
 * (sections/slideshow.liquid + assets/section-slideshow.js).
 *
 * BEFUND (gemessen 18.08.2026, Startseite, Theme Kick):
 *   Viewport 768 / 1024 / 1280 / 1440 -> H1 unsichtbar bzw. angeschnitten.
 *     computed animation-name: none, opacity: 0,
 *     transform: translateY(<line-height>), .line { overflow: hidden }
 *   Viewport 1920 und 390 -> korrekt.
 *     animation-name: slide-in, fill forwards, transform 0, opacity 1,
 *     .line style.overflow = "visible" (inline durch animateLines()).
 *
 *   Das Theme-JS parkt die Woerter in resetLines() INLINE auf
 *   opacity:0 / translate3d(0,100%,0) und verlaesst sich darauf, dass die
 *   CSS-Animation `slide-in` sie wieder herausfaehrt. Bleibt die Animation
 *   aus, bleibt die Ueberschrift hinter `overflow: hidden` stehen.
 *   Es ist also KEIN Hoehen-/line-height-Problem: die .line-Box ist mit
 *   68px bei 68px line-height korrekt bemessen, ihr Inhalt sitzt nur genau
 *   eine Zeilenhoehe zu tief (= Startzustand der Animation).
 *
 * DIESES NETZ aendert die Animation nicht. Es prueft erst NACH Ablauf der
 * maximalen Animationsdauer, ob Woerter noch unsichtbar oder verschoben
 * sind, und stellt dann exakt den Endzustand her, den das Theme bei 1920
 * von selbst erreicht. Laeuft die Animation normal, passiert nichts.
 *
 * Sobald das Theme-JS repariert ist (oder ein Theme-Update kommt), kann
 * diese Datei ersatzlos entfernt werden.
 */
(function () {
	// delay 0.8s + (Zeilenindex * 0.25s) + Dauer 0.6s -> ~1.9s bei 3 Zeilen.
	var FRIST_MS = 2600;
	var ENDZUSTAND = 'matrix(1, 0, 0, 1, 0, 0)';

	function istVerdeckt(wort) {
		var stil = getComputedStyle(wort);
		if (parseFloat(stil.opacity) < 0.9) return true;
		// 'none' = kein Transform gesetzt, Matrix-Identitaet = Endposition.
		return stil.transform !== 'none' && stil.transform !== ENDZUSTAND;
	}

	function heilen() {
		document.querySelectorAll('.slideshow-slide__title').forEach(function (titel) {
			var woerter = titel.querySelectorAll('.line .word');
			if (!woerter.length) return;
			if (!Array.prototype.some.call(woerter, istVerdeckt)) return;

			woerter.forEach(function (wort) {
				wort.style.opacity = '1';
				wort.style.transform = 'none';
			});
			titel.querySelectorAll('.line').forEach(function (zeile) {
				zeile.style.overflow = 'visible';
			});
		});
	}

	function planen() {
		setTimeout(heilen, FRIST_MS);
	}

	if (document.readyState === 'complete') planen();
	else window.addEventListener('load', planen);

	// Resize teilt die Zeilen per SplitType neu auf; danach kann derselbe
	// Zustand erneut entstehen. Entprellt nachfassen.
	var timer;
	window.addEventListener('resize', function () {
		clearTimeout(timer);
		timer = setTimeout(heilen, FRIST_MS);
	});
})();
